module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/products-v2/single-product/details/product-details.component.css
// module id = ./src/app/products-v2/single-product/details/product-details.component.css
// module chunks = main